document.addEventListener('DOMContentLoaded', () => {
    
  function initSliders() {
    const sliderContainers = document.querySelectorAll('.before-after--slider');

    sliderContainers.forEach(container => {
      const slider = container.querySelector('.slider-range');
      const afterImageContainer = container.querySelector('.after-image-container');
      const handle = container.querySelector('.slider-handle');

      function updateSlider(value) {
        const percentage = value + '%';
        // afterImageContainer.style.width = percentage;
        afterImageContainer.style.setProperty('--width', percentage);
        handle.style.left = percentage;
      }
      
      slider.addEventListener('input', (e) => {
        updateSlider(e.target.value);
      });
      
      let isDragging = false;

      function onPointerDown(e) {
        isDragging = true;
        container.style.cursor = 'grabbing';
      }

      function onPointerUp() {
        isDragging = false;
        container.style.cursor = 'ew-resize';
      }

      function onPointerMove(e) {
        if (!isDragging) return;
        
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const containerRect = container.getBoundingClientRect();
        
        let newPosition = clientX - containerRect.left;
        
        if (newPosition < 0) newPosition = 0;
        if (newPosition > containerRect.width) newPosition = containerRect.width;

        const percentage = (newPosition / containerRect.width) * 100;

        updateSlider(percentage);
        slider.value = percentage;
      }
      
      container.addEventListener('mousedown', onPointerDown);
      container.addEventListener('touchstart', onPointerDown);
      
      document.addEventListener('mouseup', onPointerUp);
      document.addEventListener('touchend', onPointerUp);
      
      document.addEventListener('mousemove', onPointerMove);
      document.addEventListener('touchmove', onPointerMove);
    });
  }
  
  initSliders();
  
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      initSliders();
    });
  }
});